<div class="container">
    <div class="loading-full" *ngIf="loading">
        <span class="loading_content">{{'crm.contact_remove_loading' |stringLiterals}}</span>
    </div>
    <div class="list-container">
        <div *ngIf="!isShowBulkAction">
            <div class="tool-bar" [ngClass]="{'hide': !config||config.hideKeyword}">
                <div class="left-menu">
                    <div tid="keyword-search" class="search-box">
                        <keyword-search [config]="keywordSearchConfig"></keyword-search>
                    </div>
                    <span class="records">{{getRecord()}}</span>
                </div>
                <div class="right-menu">
                    <div *ngIf="!isShowBulkAction" class="menu-icon">
                        <smart-icon name="refresh" class="light" (click)="clickRefreshContactList()">
                        </smart-icon>
                    </div>
                    <smart-icon [name]="filterIcon" class="light menu-icon" (click)="clickFilter($event)">
                    </smart-icon>
                    <smart-icon *ngIf="contactList&&contactList.totalCount>0&&!isExportCurrentViewAll"
                        name="export-excel" class="light menu-icon" (click)="showExcelContextMenu($event)">
                    </smart-icon>
                    <div *ngIf="isExportCurrentViewAll" class="export-loading-icon">
                        <label class="tam-loading tam-loading-gray"></label>
                    </div>
                    <div class="contact-list-meatball-operate" (click)="showContextMenu($event)">
                        <smart-icon name="meatball" class="hover-color"></smart-icon>
                    </div>
                </div>
            </div>
            <tam-context-menu [config]="exportContextMenuConfig"></tam-context-menu>
            <tam-context-menu [config]="operationContextMenuConfig"></tam-context-menu>
        </div>

        <div class="bulk-action" *ngIf="isShowBulkAction">
            <span class="h3-regular">{{'crm.contact_bulk_actions' |stringLiterals}}</span>
            <div class="bulk-button">
                <div class="actions">
                    <tam-split-button [config]="splitButtonConfig">
                    </tam-split-button>
                    <button tam-button tamType="primary" tamSize="normal" (click)="onSendEmailButtonClick()"
                        class="send-email">{{'crm.send_email_to_selected_contacts' |stringLiterals}}</button>
                </div>
                <button tam-button tamType="tertiary" tamSize="normal" (click)="onButtonClick()">
                    {{'crm.exit' |stringLiterals}}
                </button>
            </div>
            <div class="bulk-progressbar" *ngIf="isShowProgressBar">
                <span class="title-1">{{bulkProgressHeader}}</span>
                <div class="progress progress-95">
                    <div class="progress-bar" [ngClass]="progressColor" [style.width]="bulkProgress"></div>
                </div>
                <span class="body-2">{{bulkFinishedResult}}<label *ngIf="bulkFinishedTip"
                        class="bulk-red-tip">{{bulkFinishedTip}}</label></span>
            </div>
            <div class="bulk-select" *ngIf="isShowGrid">
                <span>{{checkCount()}} selected (
                    <label class="hover-link" (click)="clickSelectedAll()">{{'crm.select_all' |stringLiterals}}</label>
                    )</span>
            </div>
        </div>

        <div *ngIf="isShowGrid" class="grid" loading-spin [isLoading]="reloading" [loadingSize]="'big'"
            (click)="onGridClick($event)" (mousedown)="onMousedown($event)">
            <ag-grid-angular style="width: 100%; height: 100%;-webkit-touch-callout: default;" class="ag-theme-balham"
                [columnDefs]="columnDefs" [gridOptions]="gridOptions" (sortChanged)="onSortChanged($event)"
                (gridReady)="onGridReady($event)" (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
                (bodyScroll)="onBodyScroll($event)" (rowClicked)='onRowClicked($event)' (keydown)="onKeydown($event)"
                (columnPinned)="onColumnPinned($event)" (columnResized)="onColumnResized($event)"
                (columnVisible)="onColumnVisible($event)" (columnMoved)="onColumnMoved($event)">
            </ag-grid-angular>
            <tam-exchange-import-check-dialog></tam-exchange-import-check-dialog>
            <tam-exchange-import-list-dialog></tam-exchange-import-list-dialog>
            <tam-exchange-import-duplicate-dialog></tam-exchange-import-duplicate-dialog>
        </div>
    </div>
    <tam-contact-list-filter class="contact-list-filter" *ngIf="isShowFilter"
        (clickApplyFilter)="clickApplyFilter($event)"></tam-contact-list-filter>

</div>